{
  "name": "olympia-fitness",
  "version": "1.16.0",
  "author": "@bobbyg603",
  "homepage": "https://olympiafitnessri.app/",
  "database": "olympia-fitness",
  "scripts": {
    "ng": "ng",
    "start": "concurrently \"npx supabase start && npm run start:functions\" \"npm run serve:local\" \"npm run wait:local\" \"ngrok http 64321 --url=https://olympia-fitness.ngrok.io\"",
    "start:e2e": "concurrently \"npx supabase start && npx supabase migration up\" \"npm run build:e2e && npm run serve:e2e\"",
    "start:prod": "npm run build:prod && npx http-server www/browser",
    "start:debug": "concurrently \"npx supabase start && npm run debug:functions\" \"npm run serve:local\" \"npm run wait:local\"",
    "start:local:oauth": "sh ./scripts/start-with-local-oauth-support.sh",
    "start:functions": "npx supabase functions serve",
    "debug:functions": "npx supabase functions serve --inspect-mode brk",
    "build": "ng build",
    "build:android": "ionic capacitor build android --source-map",
    "build:android:local": "ionic capacitor build android --source-map --configuration ios-local",
    "build:ios": "ionic capacitor build ios --source-map",
    "build:ios:local": "ionic capacitor build ios --source-map --configuration ios-local",
    "build:prod": "ng build --configuration production --source-map",
    "postbuild:android": "npm run sourcemaps",
    "postbuild:ios": "npm run sourcemaps",
    "postbuild:prod": "npm run sourcemaps",
    "db:reset": "npx supabase db reset",
    "db:push": "npx supabase db push",
    "db:pull": "npx supabase db pull",
    "db:seed": "ts-node supabase/data/create.ts",
    "db:stop": "npx supabase stop",
    "db:types": "npx supabase gen types typescript --local > src/types/supabase.ts && cp src/types/supabase.ts supabase/types/supabase.ts",
    "serve:local": "ng serve --configuration local --port 4201",
    "serve:verify": "ng serve --configuration verify --port 4201",
    "serve:local:https": "ng serve --configuration local-https --port 4201",
    "serve:local:oauth": "ng serve --configuration local-oauth --port 4201",
    "serve:ios:local": "ng serve --configuration ios-local --port 4201",
    "studio:local": "open \"http://localhost:64323/\"",
    "proxy:supabase": "node scripts/supabase-https-proxy.js",
    "wait:local": "wait-on http://localhost:4201 && open http://localhost:4201",
    "wait:local:https": "wait-on https://olympiafitnessri-dev.com:4201 && open https://olympiafitnessri-dev.com:4201",
    "sourcemaps": "node -r dotenv/config $(which npx) @bugsplat/symbol-upload -d ./www/browser",
    "watch": "ng build --watch --configuration development",
    "test": "export NODE_OPTIONS='--max-old-space-size=16384' && ng test --no-watch",
    "test:watch": "ng test",
    "lint": "export NODE_OPTIONS='--max-old-space-size=16384' && ng lint --fix --cache",
    "e2e": "playwright test",
    "e2e:check": "sh ./scripts/e2e-check.sh",
    "build:e2e": "ng build --configuration local",
    "serve:e2e": "http-server www/browser -p 4201 -s --proxy \"http://localhost:4201?\"",
    "e2e:headed": "playwright test --headed"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.4",
    "@angular/cdk": "^22.1.4",
    "@angular/common": "^22.1.4",
    "@angular/compiler": "^22.1.4",
    "@angular/core": "^22.1.4",
    "@angular/forms": "^22.1.4",
    "@angular/platform-browser": "^22.1.4",
    "@angular/platform-browser-dynamic": "^22.1.4",
    "@angular/router": "^22.1.4",
    "@awesome-cordova-plugins/core": "8.1.0",
    "@awesome-cordova-plugins/media-capture": "8.1.0",
    "@capacitor/android": "^8.0.0",
    "@capacitor/app": "^8.0.0",
    "@capacitor/camera": "^8.0.0",
    "@capacitor/core": "^8.0.0",
    "@capacitor/filesystem": "^8.0.0",
    "@capacitor/haptics": "^8.0.0",
    "@capacitor/ios": "^8.0.0",
    "@capacitor/keyboard": "^8.0.0",
    "@capacitor/share": "^8.0.0",
    "@capacitor/status-bar": "^8.0.0",
    "@capgo/capacitor-social-login": "^8.5.10",
    "@ionic/angular": "^9.0.1",
    "@ionic/angular-server": "^9.0.1",
    "@ionic/pwa-elements": "^3.3.0",
    "@ionic/storage": "^4.0.0",
    "@ionic/storage-angular": "^4.0.0",
    "@supabase/supabase-js": "^2.89.0",
    "bugsplat-ng": "^18.0.1",
    "chart.js": "^4.5.0",
    "chartjs-plugin-datalabels": "^2.2.0",
    "cordova-plugin-file": "8.1.3",
    "cordova-plugin-media-capture": "^6.0.0",
    "ionicons": "^8.0.13",
    "jspdf": "^4.2.1",
    "mime": "^4.0.7",
    "ng-mocks": "^14.13.5",
    "ng2-charts": "^10.0.0",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "tus-js-client": "^4.3.1",
    "validator": "^13.15.15"
  },
  "devDependencies": {
    "@angular-devkit/core": "^22.1.6",
    "@angular-devkit/schematics": "^22.1.6",
    "@angular-eslint/builder": "^22.1.0",
    "@angular-eslint/eslint-plugin": "^22.1.0",
    "@angular-eslint/eslint-plugin-template": "^22.1.0",
    "@angular-eslint/schematics": "^22.1.0",
    "@angular-eslint/template-parser": "^22.1.0",
    "@angular/build": "^22.1.6",
    "@angular/cli": "^22.1.6",
    "@angular/compiler-cli": "^22.1.4",
    "@angular/language-service": "^22.1.4",
    "@bugsplat/symbol-upload": "^10.1.11",
    "@bugsplat/vitest-auto-spies": "^1.0.0",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "^8.0.0",
    "@ionic/angular-toolkit": "^13.0.0",
    "@playwright/test": "^1.55.0",
    "@types/node": "^24.10.3",
    "@types/validator": "^13.15.2",
    "@typescript-eslint/eslint-plugin": "^8.41.0",
    "@typescript-eslint/parser": "^8.41.0",
    "@typescript-eslint/utils": "^8.41.0",
    "angular-eslint": "^22.1.0",
    "concurrently": "^9.2.1",
    "dotenv": "^17.2.1",
    "eslint": "^9.34.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsdoc": "^54.1.1",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-prettier": "^5.5.4",
    "express": "^5.1.0",
    "http-proxy-middleware": "^3.0.5",
    "http-server": "^14.1.1",
    "jsdom": "^27.4.0",
    "jsonwebtoken": "^9.0.2",
    "local-ssl-proxy": "^2.0.5",
    "prettier": "^3.6.2",
    "prettier-eslint": "^16.4.2",
    "supabase": "^2.70.5",
    "ts-node": "^10.9.2",
    "typescript": "6.0.3",
    "typescript-eslint": "^8.68.0",
    "vitest": "^4.1.11",
    "wait-on": "^8.0.4"
  },
  "description": "An Ionic project",
  "browserslist": [
    "Chrome >= 119",
    "ChromeAndroid >= 119",
    "Firefox >= 119",
    "Edge >= 119",
    "Safari >= 17",
    "iOS >= 17"
  ]
}